/*
Aditya 09/26/2022  3075154998  Changed DM label to Data mananger
Dilip  10/11/2022  3075154998  Data Manager Matching logic changes
Akhila  10/28/2022 3075154998 data manager ux changes
Suresh Peddavoora 10/28/2022 3075154998  Data Manager sub tabs spacing alignments
*/
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddDMRecordGroup from './AddDMRecordGroup';
import SearchDMRecordGroup from './SearchDMRecordGroup';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
}));

export default function RuleGroupTabs() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [filterCode, setFilterCode] = useState(null);
  return (
    <div className={classes.root}>
      <div className={classes.searchRuleButton}>
        {/* <AntTabs
          className={classes.demo1}
          value={value}
          onChange={handleChange}
          aria-label="ant example"
          variant="scrollable"
          scrollButtons="auto"
        > */}
        {/* <AntTab label="Search Record Group" />
          <AntTab label="Add Record Group" /> */}
        {/* </AntTabs> */}
        <Typography />
      </div>
      <div className={classes.subContent}>
        {value === 0 && (
          <SearchDMRecordGroup setValue={setValue} setFilterCode={setFilterCode} />
        )}
        {value === 1 && <AddDMRecordGroup setValue={setValue} filterCode={filterCode} setFilterCode={setFilterCode} />}
      </div>
    </div>
  );
}
